import styled from 'styled-components';

export const Separator = styled.hr`
	width: 100%;
	margin: 5rem 0;
	border: 0;
	border-bottom: 0.1rem solid #d8d8d8;
`;
